import { images } from "../../../../Assets/assetsHelper";
import "./CategoryDetails.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import DeleteForm from "../../../../Components/Molecules/DeleteForm/DeleteForm";
import FormModal from "../../../../Components/Molecules/FormModal/FormModal";
import AgeGroupForm from "../../../../Components/Organisms/Forms/AgeGroupForm/AgeGroupForm";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box } from "@mui/material";
import { useState, useEffect } from "react";

function CategoryDetails({
  loading,
  category,
  ageGroups,
  ageGroupsLoading,
  categoryId,
  setGoDelete,
  onAddAgeGroup,
  onUpdateAgeGroup,
  onDeleteAgeGroup,
  editingAgeGroupId,
  setEditingAgeGroupId,
  saveAgeGroupLoading,
  updateAgeGroupLoading,
  onToggleActive,
  updateActiveLoading,
}) {
  const navigate = useNavigate();
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteAgeGroupId, setDeleteAgeGroupId] = useState(null);
  const [goDeleteAgeGroup, setGoDeleteAgeGroup] = useState(false);

  // Handle delete age group - wrapper for DeleteForm
  const handleDeleteAgeGroupClick = (ageGroupId) => {
    setDeleteAgeGroupId(ageGroupId);
  };

  useEffect(() => {
    if (goDeleteAgeGroup && deleteAgeGroupId) {
      onDeleteAgeGroup(deleteAgeGroupId);
      setGoDeleteAgeGroup(false);
      setDeleteAgeGroupId(null);
    }
  }, [goDeleteAgeGroup, deleteAgeGroupId, onDeleteAgeGroup]);

  // Close modals after successful submission
  useEffect(() => {
    if (!saveAgeGroupLoading && openAddModal) {
      setOpenAddModal(false);
    }
  }, [saveAgeGroupLoading]);

  useEffect(() => {
    if (!updateAgeGroupLoading && openEditModal) {
      setOpenEditModal(false);
      setEditingAgeGroupId(null);
    }
  }, [updateAgeGroupLoading]);
  return (
    <div className="mainContainer">
      {category && !loading ? (
        <div className="SchoolCont">
          <div className="EditDeleteHeader">
            {category?.canEditCategoryPriceOrDeleteCategory ? (
              <PrimaryButton
                classBtn={"center editButton"}
                text={"Edit Category"}
                style={{
                  textTransform: "capitalize",
                  borderRadius: "5px",
                  color: "white",
                  backgroundColor: "var(--primary)",
                  height: "40px",
                  padding: "0 20px",
                  minWidth: "140px",
                  fontSize: "14px",
                }}
                click={() => navigate(`/categories/${categoryId}/edit`)}
              />
            ) : (
              ""
            )}
            <PrimaryButton
              classBtn={"center editButton"}
              text={category?.active ? "Deactivate" : "Activate"}
              loading={updateActiveLoading}
              disabled={updateActiveLoading}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "white",
                backgroundColor: category?.active ? "#757575" : "#4caf50",
                height: "40px",
                padding: "0 20px",
                minWidth: "140px",
                fontSize: "14px",
              }}
              click={onToggleActive}
            />
            {category?.canEditCategoryPriceOrDeleteCategory ? (
              <DeleteForm
                setGo={setGoDelete}
                title={`Are you sure you want to delete "${category.name}"?`}
              />
            ) : (
              ""
            )}
          </div>
          <div className="greyBox">
            <div className="detailsHeaderBox">
              <div className="detailsHeaderBoxInside">
                <div className="SchoolDetails">
                  <h2 style={{ fontSize: "28px", margin: "0 0 10px 0" }}>
                    {category.name}
                  </h2>
                  <h3 style={{ marginTop: "18px", fontWeight: "400" }}>
                    Status:{" "}
                    <strong
                      style={{
                        color: category?.active ? "#4caf50" : "#757575",
                        textTransform: "uppercase",
                      }}
                    >
                      {category?.active ? "Active" : "Inactive"}
                    </strong>
                  </h3>
                  <h3 style={{ marginTop: "18px", fontWeight: "400" }}>
                    Payment Type:{" "}
                    <strong>{category?.categoryPrice?.type}</strong>
                  </h3>
                  {category?.categoryPrice?.type == "team" ? (
                    <>
                      {category?.categoryPrice?.teamPrices?.map((item) => (
                        <h3 style={{ marginTop: "18px", fontWeight: "400" }}>
                          Team Price ({item?.priceAmount?.currency?.code}):{" "}
                          <strong>
                            {(item?.priceAmount?.amountCents / 100).toFixed(2)}{" "}
                            {item?.priceAmount?.currency?.code}
                          </strong>
                        </h3>
                      ))}
                    </>
                  ) : category?.categoryPrice?.type == "member" ? (
                    <>
                      {category?.categoryPrice?.memberPrices?.map((item) => (
                        <h3 style={{ marginTop: "18px", fontWeight: "400" }}>
                          Member Price ({item?.priceAmount?.currency?.code}):{" "}
                          <strong>
                            {(item?.priceAmount?.amountCents / 100).toFixed(2)}{" "}
                            {item?.priceAmount?.currency?.code}
                          </strong>
                        </h3>
                      ))}
                    </>
                  ) : (
                    <>
                      {category?.categoryPrice?.membersGroupPrices?.map(
                        (item) => (
                          <h3 style={{ marginTop: "18px", fontWeight: "400" }}>
                            Members Count: <strong>{item?.count}</strong>{" "}
                            {item?.membersGroupCountPrice?.map((price) => (
                              <span>
                                {" "}
                                - Price ({
                                  price?.priceAmount?.currency?.code
                                }):{" "}
                                <strong>
                                  {(
                                    price?.priceAmount?.amountCents / 100
                                  ).toFixed(2)}{" "}
                                  {price?.priceAmount?.currency?.code}
                                </strong>
                              </span>
                            ))}
                          </h3>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", md: "center" },
              margin: "0 0 20px 20px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <h2 style={{ fontSize: "24px" }}>Age Groups:</h2>
            <PrimaryButton
              classBtn={"center addButton"}
              startIcon={<AddIcon />}
              text={"Add Age Group"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "white",
                backgroundColor: "var(--primary)",
                height: "40px",
                padding: "0 20px",
                minWidth: "150px",
              }}
              click={() => setOpenAddModal(true)}
            />
          </Box>
          {ageGroups?.length > 0 ? (
            <div className="ageGroupsGrid">
              {ageGroups?.map((item) => (
                <div
                  key={item.id}
                  className="greyBoxWhite"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="greyNumberBox">
                      <div>
                        <h4>Age Group Name: </h4>
                        <h2 style={{ fontSize: "20px" }}>{item?.name}</h2>
                      </div>
                    </div>
                    <div className="greyNumberBox">
                      <div>
                        <h4>Min Memebers: </h4>
                        <h2 style={{ fontSize: "20px" }}>{item?.minMembers}</h2>
                      </div>
                    </div>
                    <div className="greyNumberBox">
                      <div>
                        <h4>Max Members: </h4>
                        <h2 style={{ fontSize: "20px" }}>{item?.maxMembers}</h2>
                      </div>
                    </div>
                    <div className="greyNumberBox">
                      <div>
                        <h4>Min Birthday: </h4>
                        <h2 style={{ fontSize: "20px" }}>
                          {new Date(item?.minBirthday).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                        </h2>
                      </div>
                    </div>
                    <div className="greyNumberBox">
                      <div>
                        <h4>Max Birthday: </h4>
                        <h2 style={{ fontSize: "20px" }}>
                          {new Date(item?.maxBirthday).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="ageGroupActions">
                    <PrimaryButton
                      classBtn={"center editButton"}
                      text={"Edit"}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "5px",
                        color: "white",
                        backgroundColor: "var(--primary)",
                        height: "40px",
                        padding: "0 15px",
                        fontSize: "14px",
                      }}
                      click={() => {
                        setEditingAgeGroupId(item.id);
                        setOpenEditModal(true);
                      }}
                    />
                    <DeleteForm
                      setGo={(value) => {
                        if (value) {
                          handleDeleteAgeGroupClick(item.id);
                          setGoDeleteAgeGroup(true);
                        }
                      }}
                      title={`Are you sure you want to delete "${item.name}"?`}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="emptyMessage">
              <h2>No age groups found</h2>
            </div>
          )}

          {/* Add Age Group Modal */}
          <FormModal
            Open={openAddModal}
            HandleClose={() => setOpenAddModal(false)}
            XButton={true}
            Form={
              <AgeGroupForm
                onSubmit={(formData) => {
                  onAddAgeGroup(formData);
                }}
                onCancel={() => setOpenAddModal(false)}
                loading={saveAgeGroupLoading}
              />
            }
            Title="Add Age Group"
            CustomStyle="medium"
          />

          {/* Edit Age Group Modal */}
          <FormModal
            Open={openEditModal && editingAgeGroupId !== null}
            HandleClose={() => {
              setOpenEditModal(false);
              setEditingAgeGroupId(null);
            }}
            XButton={true}
            Form={
              <AgeGroupForm
                onSubmit={(formData) => {
                  onUpdateAgeGroup(formData);
                }}
                onCancel={() => {
                  setOpenEditModal(false);
                  setEditingAgeGroupId(null);
                }}
                initialValues={
                  ageGroups.find((ag) => ag.id === editingAgeGroupId) || null
                }
                loading={updateAgeGroupLoading}
              />
            }
            Title="Edit Age Group"
            CustomStyle="medium"
          />
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default CategoryDetails;
